module.exports = __webpack_public_path__ + "static/media/bangalore-zoo.9babbdc9.jpg";